import React from 'react';
import PropTypes from 'prop-types';
import { List, ListSubheader } from '@mui/material';
import { styled, useTheme } from '@mui/styles';
import useUserPermissions from 'src/hooks/useUserPermissions';
import { omit } from 'src/utils/helpers/object';
import NavBarDivider from 'src/components/widgets/NavBarDivider';
import MenuItem from './MenuItem';

const StyledListSubheader = styled(ListSubheader)({
  '&.MuiListSubheader-root': {
    // color: grey[400],
    lineHeight: 'unset',
    fontSize: '.80rem'
  }
});

const MenuList = ({ menu, drawerMode }) => {
  const theme = useTheme();
  const { hasPermission } = useUserPermissions();

  return (
    <>
      <List
        sx={{
          marginLeft: menu.title ? theme.spacing(1) : '0',
          marginBottom: menu.title ? theme.spacing(2) : theme.spacing(1),
          marginTop: menu.title ? theme.spacing(0.5) : '0'
        }}
        subheader={
          drawerMode === 'full' &&
          !menu.hide_title && (
            <StyledListSubheader disableGutters disableSticky>
              {menu.title}
            </StyledListSubheader>
          )
        }
      >
        {menu.items
          .filter((item) => {
            if (item.isEAP) {
              return hasPermission('EAP', 'menuKeys', item);
            }
            return true;
          })
          .map((item) => {
            const itemProps = omit(item, 'isEAP');
            return (
              <MenuItem
                {...itemProps}
                key={itemProps.title}
                drawerMode={drawerMode}
              />
            );
          })}
      </List>
      {menu.divider && <NavBarDivider />}
    </>
  );
};

MenuList.propTypes = {
  menu: PropTypes.object,
  drawerMode: PropTypes.string
};

export default MenuList;
